import { castArray, head, map, size } from "lodash";
import { Facet } from "@linkfluence/models/facet";
import { Clause } from "@radarly/models/clause";
import { transformToCustomFieldClause } from "@radarly/models/clause/transformer";

function getRatingClause(from: number, to?: number) {
  const reviews = {
    "0": { min: 0, max: 0 },
    "1": { min: 0.1, max: 30 },
    "2": { min: 30.1, max: 50 },
    "3": { min: 50.1, max: 70 },
    "4": { min: 70.1, max: 99.9 },
    "5": { min: 100, max: 100 },
  };
  return { gt: reviews[from].min, lt: reviews[to ? to : from].max };
}

function getInnerClause(field: string, filters: Array<string | number>) {
  if (size(filters)) {
    if (field === Facet.ReviewRate) {
      return { [field]: getRatingClause(Number(head(filters))) };
    }
    return { [field]: map(filters, String) };
  }
  return null;
}

export function getFocusClause(
  field: string,
  filters: string | number | Array<string | number>,
  custom?: boolean
): Clause {
  const nextClause = getInnerClause(field, castArray(filters));
  return {
    and: [custom ? transformToCustomFieldClause(nextClause) : nextClause],
  };
}
